/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Windows_1Inputs */

const en_pc_dl_windows_1 = /** @type {(inputs: Pc_Dl_Windows_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the x64 installer (.msi). Snapdragon and other ARM laptops need ARM64; old 32-bit Windows needs x86.`)
};

const zh_pc_dl_windows_1 = /** @type {(inputs: Pc_Dl_Windows_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 x64 安装包（.msi）。骁龙等 ARM 笔记本请选 ARM64，老旧的 32 位 Windows 请选 x86。`)
};

/**
* | output |
* | --- |
* | "Download the x64 installer (.msi). Snapdragon and other ARM laptops need ARM64; old 32-bit Windows needs x86." |
*
* @param {Pc_Dl_Windows_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_windows_1 = /** @type {((inputs?: Pc_Dl_Windows_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Windows_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_windows_1(inputs)
	return zh_pc_dl_windows_1(inputs)
});
export { pc_dl_windows_1 as "pc.dl.windows.1" }